import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'

// Const
import { PATH_MY_ACCOUNT } from 'routes/paths'

// Use
import { useParams } from 'react-router-dom'
import useMounted from 'use/mounted'
import useQuery from 'use/query'

// Notifications slice
import { markAsRead } from 'store/modules/notifications'

// Models
import ContractModel from 'models/Contract'

// Api
import { getContractInfo } from 'api/contract'

// Components
import Row from 'ui/Row'
import Col from 'ui/Col'
import Loading from 'ui/Loading'
import Header from 'ui/Header'
import Navbar from 'ui/Navbar'
import Container from 'ui/Container'
import Breadcrumb from 'ui/Breadcrumb'
import ContractInfo from 'components/Payment/ContractInfo'
import ContractSummary from 'components/Payment/ContractSummary'
import PaymentTracker from 'components/Payment/PaymentTracker'

const breadcrumbs = [
  {
    label: 'Account & payments',
    path: PATH_MY_ACCOUNT,
  },
  {
    label: 'View full details',
  },
]

export default function PageContractView() {
  const dispatch = useDispatch()
  const isMounted = useMounted()
  const { companyCode, vendorCode, contractNumber } = useParams()
  const { notificationId, lessorId, companyId, vendorId } = useQuery()

  // State
  const [loading, setLoading] = useState(false)
  const [contract, setContract] = useState(new ContractModel())

  useEffect(() => {
    setLoading(true)

    dispatch(markAsRead(notificationId))

    getContractInfo({ contractNumber, vendorCode, companyCode, notificationId })
      .then((data) => {
        if (isMounted.current) {
          setContract(data)
        }
      })
      .finally(() => {
        if (isMounted.current) {
          setLoading(false)
        }
      })
  }, [
    companyCode,
    contractNumber,
    dispatch,
    isMounted,
    notificationId,
    vendorCode,
  ])

  return (
    <>
      <Header />
      <Navbar />
      <Container>
        <Breadcrumb items={breadcrumbs} />
        <Loading spinning={loading}>
          <Row style={{ marginBottom: '35px' }}>
            <Col xs={12} sm={12} md={12} lg={6} xl={6}>
              <ContractInfo contract={contract} />
            </Col>
          </Row>
          <Row>
            <Col>
              <ContractSummary
                companyCode={companyCode}
                vendorCode={vendorCode}
                contractNumber={contractNumber}
                contract={contract}
                fullWidth={false}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <PaymentTracker
                companyCode={companyCode}
                vendorCode={vendorCode}
                contractNumber={contractNumber}
                lessorId={lessorId}
                vendorId={vendorId}
                companyId={companyId}
              />
            </Col>
          </Row>
        </Loading>
      </Container>
    </>
  )
}
